<div class="backdrop" #backdropRef></div>

<div class="details-area card p-3" [class.extra-size]="$isDetailsAreaExtraSize()" #detailsAreaRef>
    <ngx-spinner name="detailsAreaSpinner" bdColor="rgba(255, 255, 255, 1)" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

    <i class="button close fa fa-times" matTooltip="Fechar"
       (click)="closeModalAreas()"
       (keyDown)="closeModalAreas()"
    ></i>

    <mat-tab-group disablePagination="true" #matTabGroupRef
                   [(selectedIndex)]="activeTabIndex"
                   (selectedTabChange)="tabChanged($event)"
    >
        <!-- Detalhes do Fluxo -->
        @if ($isAreaVisible().flowDefinitionDetails) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.FlowDefinitionDetails)">
                <fdd-default #flowDefinitionDetailsRef
                             [_model]="$flowDefinition()"
                             [_isReadOnlyMode]="$isReadOnlyMode()"
                             [_flowTargetOptions]="flowTargetOptions"
                             [_shouldLoadTinyMce]="$shouldLoadFlowDefinitionDetailsTinyMce()"
                             [_isCreate]="$isCreate()"
                             (_updateFlowDefinitionEvent)="_updateFlowDefinitionEvent.emit($event)"
                             (_closeEvent)="closeModalAreas()"
                ></fdd-default>
            </mat-tab>
        }

        <!-- Configurações Imediatas -->
        @if ($isAreaVisible().flowDefinitionDetailsHotConfigs && $isLatestVersion()) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.FlowDefinitionDetailsHotConfigs)">
                <fdd-hot-configs #flowDefinitionDetailsHotConfigsRef
                                 [_model]="$flowDefinition()"
                                 (_updateFlowDefinitionEvent)="_updateFlowDefinitionHotConfigsEvent.emit($event)"
                                 (_closeEvent)="closeModalAreas()"
                ></fdd-hot-configs>
            </mat-tab>
        }

        <!-- Detalhes -->
        @if (!$isAreaVisible().flowDefinitionDetails && !$isAreaVisible().flowDefinitionDetailsHotConfigs) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.FlowObjectDetails)">
                @if ($isAreaVisible().flowObjectDetails) {
                    <fod-default #flowObjectDetailsRef
                                 [_model]="$flowObjectDefinition()"
                                 [_flowDefinition]="$flowDefinition()"
                                 [_isReadOnlyMode]="$isReadOnlyMode()"
                                 [_ongoingTinyMceRecycle]="$ongoingTinyMceRecycle()"
                                 (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                 (_closeEvent)="toggleEditArea()"
                    ></fod-default>
                }
            </mat-tab>
        }

        <!-- Construtor de Formulário -->
        @if ($isAreaVisible().formBuilder) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.FormBuilder)">
                <h6>Edite aqui a estrutura do formulário que será exibido para o usuário ao se executar esta tarefa.</h6>
                <hr>
                <fod-form #flowObjectFormRef
                          [_model]="$flowObjectDefinition()"
                          [_flowDefinition]="$flowDefinition()"
                          [_isReadOnlyMode]="$isReadOnlyMode()"
                          (_submitEvent)="onSubmitForm($event)"
                          (_closeEvent)="toggleEditArea()"
                ></fod-form>
            </mat-tab>
        }

        <!-- Construtor de Formulário: Iniciar por API -->
        @if ($isAreaVisible().formBuilderInboundApi) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.FormBuilderInboundApi)">
                <h6>Liste aqui os anexos enviados pelo sistema de origem que serão capturados como Documentos no E-Docs.</h6>
                <hr>
                <fod-start-inbound-api #flowObjectStartInboundApiRef
                                       [_model]="$flowObjectDefinition()"
                                       [_flowDefinition]="$flowDefinition()"
                                       [_isReadOnlyMode]="$isReadOnlyMode()"
                                       (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                       (_closeEvent)="toggleEditArea()"
                ></fod-start-inbound-api>
            </mat-tab>
        }

        <!-- Editor de Modelo de Documento -->
        @if ($isAreaVisible().htmlEditor) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.HtmlEditor)">
                <h6>Edite aqui a estrutura do documento que será enviado ao E-Docs como resultado do preenchimento do formulário desta tarefa.</h6>
                <hr>
                @if ($shouldShowModelEditor()) {
                    <fod-model-editor #modelEditorRef
                                      [_model]="$tinyMceContent()"
                                      [_tinyMceOptions]="$tinyMceModelEditorOptions()"
                                      [_isReadOnlyMode]="$isReadOnlyMode()"
                                      (_modelChange)="$tinyMceContent.set($event)"
                                      (_onInitNgModelEvent)="tinyMceFinishedLoading()"
                                      (_toggleEditAreaEvent)="toggleEditArea()"
                                      (_updateHtmlEditorAreaEvent)="_updateFlowObjectEvent.emit(Object.assign($flowObjectDefinition(), { documentHtmlContent: $tinyMceContent() }))"
                    ></fod-model-editor>
                }
            </mat-tab>
        }

        <!-- Aplicação de Regra -->
        @if ($isAreaVisible().gatewayRules) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.GatewayRules)">
                <fod-gateway-rules #flowObjectGatewayRulesRef
                                   [_model]="$flowObjectDefinition()"
                                   [_isReadOnlyMode]="$isReadOnlyMode()"
                                   (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                   (_closeEvent)="toggleEditArea()">
                </fod-gateway-rules>
            </mat-tab>
        }

        <!-- Divisão de Fluxo -->
        @if ($isAreaVisible().gatewayPaths) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.GatewayPaths)">
                <fod-gateway-paths #flowObjectGatewayPathsRef
                                   [_model]="$flowObjectDefinition()"
                                   [_flowDefinition]="$flowDefinition()"
                                   [_isReadOnlyMode]="$isReadOnlyMode()"
                                   (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                   (_closeEvent)="toggleEditArea()">
                </fod-gateway-paths>
            </mat-tab>
        }

        <!-- API de Destino (Intermediária) -->
        @if ($isAreaVisible().midApi) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.MidwayOutboundApi)">
                <fod-midway-outbound-api #flowObjectMidwayOutboundApiRef
                                         [_model]="$flowObjectDefinition()"
                                         [_flowDefinition]="$flowDefinition()"
                                         [_isReadOnlyMode]="$isReadOnlyMode()"
                                         [_isCreate]="$isCreate()"
                                         (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                         (_closeEvent)="toggleEditArea()"
                ></fod-midway-outbound-api>
            </mat-tab>
        }

        <!-- API de Destino (Final) -->
        @if ($isAreaVisible().api) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.OutboundApi)">
                <fod-outbound-api #flowObjectOutboundApiRef
                                  [_model]="$flowObjectDefinition()"
                                  [_flowDefinition]="$flowDefinition()"
                                  [_isReadOnlyMode]="$isReadOnlyMode()"
                                  [_isCreate]="$isCreate()"
                                  (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                  (_closeEvent)="toggleEditArea()"
                ></fod-outbound-api>
            </mat-tab>
        }

        <!-- Conteúdo Extra -->
        @if ($isAreaVisible().extraContent) {
            <mat-tab [label]="DetailsAreaTabsLabel.get(DetailsAreaTabs.ExtraContent)">
                <fod-extra-content #flowObjectExtraContentRef
                                   [_model]="$flowObjectDefinition()"
                                   [_flowDefinition]="$flowDefinition()"
                                   [_isReadOnlyMode]="$isReadOnlyMode()"
                                   [_tinyMceOptionsMessage]="$tinyMceExtraContentOptionsMessage()"
                                   [_tinyMceOptionsWaitingMessage]="$tinyMceExtraContentOptionsWaitingMessage()"
                                   (_submitEvent)="_updateFlowObjectEvent.emit($event)"
                                   (_closeEvent)="toggleEditArea()"
                ></fod-extra-content>
            </mat-tab>
        }
    </mat-tab-group>
</div>
